
import Vue from "vue"
import {mapActions} from "vuex"
import Auth from "@/views/Auth/components/Auth.vue"
import PasswordCreationForm from "@/components/forms/PasswordCreationForm.vue"
import {Credentials} from "@/views/Auth/models/auth"
import {passwordCreationErrorText} from "@/views/Auth/utils/authErrors"

export default Vue.extend({
  name: "Register",

  components: {
    PasswordCreationForm,
    Auth,
  },

  data() {
    return {
      saving: false,
      errorText: "",
    }
  },

  methods: {
    ...mapActions("auth", ["create"]),

    createNewPassword(data: Credentials) {
      if (this.saving) return
      this.saving = true
      this.errorText = ""
      this.create({password: data, hash: this.$route.params.id})
        .then(() => {
          this.saving = false
          this.$message.success("Пароль сохранён. Войдите с новым паролем", 3)
          this.$router.push("/")
        })
        .catch((error: any) => {
          this.saving = false
          this.errorText = passwordCreationErrorText(error)
        })
    },
  },
})
